/**
 * VIVA HUB IT Technical Support page
 */

import React from 'react'
import HubLayout from '../components/hub/HubLayout'
import HubSupportPanel from '../components/hub/HubSupportPanel'

export default function HubSupport () {
  return (
    <HubLayout appName="IT Technical Support">
      <h1 className="text-2xl font-bold text-gray-900 mb-2">IT Technical Support</h1>
      <p className="mb-6 text-sm text-gray-600">
        Submit a request for Google Workspace, email, passwords, permissions, VIVA HUB, Room
        Scheduler, CRM, software licenses, printer, Wi‑Fi, or other IT issues.
      </p>
      <HubSupportPanel />
    </HubLayout>
  )
}
